import { render } from "./Spacer.vue?vue&type=template&id=1f54b1ec&scoped=true"
import script from "./Spacer.vue?vue&type=script&lang=js"
export * from "./Spacer.vue?vue&type=script&lang=js"

import "./Spacer.vue?vue&type=style&index=0&id=1f54b1ec&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\mfeys\\Desktop\\HAv2\\actions\\19480-florette\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f54b1ec"]])

export default __exports__